import React from 'react';
import Type from 'prop-types';
import { List } from "@mui/material";

const TaskSections = (props) => {
  const { children } = props;

  return <List>{children}</List>;
};

TaskSections.propTypes = {
  children: Type.node.isRequired,
};

export default TaskSections;
